// extracted by mini-css-extract-plugin
export default {"container":"Gq-z","heading":"Hq-z","text":"Iq-z","info":"Jq-z","link":"Kq-z","fullMaxWidth":"Lq-z"};